<template>
  <sa-page-layout :btnBackVisible="true" :linkback="linkback" :linkedit="linkedit" :pathResource="pathResource" :showModalLoading="showModalLoading" :btnRefreshVisible="false" @refresh="onRefresh">
    <template slot="toolbar-title">
      <rsa-ospite-anagrafica-component :jsonData="jsonData"></rsa-ospite-anagrafica-component>
    </template>
    <template slot="table-body">
      <rsa-paziente-referto-list-component ref="cmpRsaPazienteRefertoListComponent"></rsa-paziente-referto-list-component>
    </template>
  </sa-page-layout>
</template>
<script>
import axios from "axios";
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaOspiteAnagraficaComponent from "../../rsagestioneospiti/components/RsaOspiteAnagraficaComponent.vue";
import RsaPazienteRefertoListComponent from "../components/RsaPazienteRefertoListComponent.vue";

export default {
  props: {
    utente: { type: Object },
  },
  components: {
    SaPageLayout,
    RsaOspiteAnagraficaComponent,
    RsaPazienteRefertoListComponent,
  },
  data() {
    return {
      idAccettazione: null,
      linkback: "/rsagestioneospiti",
      linkedit: null,
      jsonData: { accettazioneAnagrafica: {}, accettazionePrestazioni: {}, accettazioneStati: [], accettazioneStruttura: {}, accettazionePresidio: {} },
      pathResource: null,
      pathResourceAccettazione: "/accettazioni",
      showModalLoading: false,
      listKey: 0,
    };
  },
  mounted() {
    let me = this;
    me.idAccettazione = this.$route.query.idAccettazione;
    console.log("idAccettazione", me.idAccettazione);
    me.loadAccettazione();
  },
  methods: {
    loadAccettazione() {
      let me = this;
      me.showModalLoading = true;
      console.log("idAccettazione2112", me.idAccettazione);
      let link = process.env.VUE_APP_PATH_API + me.pathResourceAccettazione + "/" + me.idAccettazione;
      axios
        .get(link)
        .then((response) => {
          me.jsonData = response.data.data;
          me.$refs.cmpRsaPazienteRefertoListComponent.loadData(me.idAccettazione);
          me.showModalLoading = false;
        })
        .catch(() => {
          me.showModalLoading = false;
        });
    },

    onRefresh() {
      let me = this;
      me.$refs.cmpRsaPazienteRefertoListComponent.loadData();
    },
  },
};
</script>
